import { documentAvailable } from '~/utils/client-detection';

const leafletRoutingMachine = documentAvailable() ? document.createElement('link') : undefined;
if (leafletRoutingMachine) {
	leafletRoutingMachine.type = 'text/css';
	leafletRoutingMachine.rel = 'stylesheet';
	leafletRoutingMachine.href = 'https://d1p8elq7q5x0x6.cloudfront.net/ngc/ngc-css/leaflet-routing-machine.css';
}

const leaflet = documentAvailable() ? document.createElement('link') : undefined;
if (leaflet) {
	leaflet.type = 'text/css';
	leaflet.rel = 'stylesheet';
	leaflet.href = 'https://d1p8elq7q5x0x6.cloudfront.net/ngc/ngc-css/leaflet.css';
}

export { leaflet, leafletRoutingMachine };
